import React, { useState, useCallback, useEffect, useRef } from "react";
import { ThemeProvider } from "@mui/material/styles";
import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  MenuItem,
  Tooltip,
  Card,
} from "@mui/material";
import {
  StyledTableCellHistory,
  StyledTableRowHistory,
  StyledTextField,
  StyledButton,
  OutlinedIconFab,
  theme,
  StyledMultilineTextField,
} from "../StyledComponents";
import Suggestions from "../Utils/Suggestions";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import ClearIcon from "@mui/icons-material/Clear";
import Icon from "../Utils/Icons";
import { InvestigationsSimplifiedTable } from "./InvestigationsSimplifiedTable";

const InvestigationsSimplified = ({
  sectionName,
  activeSection,
  suggestions,
  aiSuggestionToggle,
  ruleSuggestionToggle,
  handleCrossButtonClick,
  data,
  setData,
  startRecording,
  stopRecording,
  isAiEnabled,
}) => {
  console.log("Inside Tests and Investigations", data);

  const [listeningOn, setListeningOn] = useState(false);
  const [newInvestigation, setNewInvestigation] = useState({
    term: "",
    id: null,
    clinical_note: "",
  });

  const [investigationName, setInvestigationName] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [investigations, setInvestigations] = useState(data);
  const [validationErrors, setValidationErrors] = useState({
    term: "",
  });

  useEffect(() => {
    setInvestigations(data);
  }, [data]);

  const validateFields = () => {
    const errors = {};

    if (!newInvestigation.term && investigationName.length === 0) {
      errors.term = "Tests/Investigations Name is a mandatory field.";
    }

    setValidationErrors(errors);

    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const handleAdd = async () => {
    if (!validateFields()) return;

    let newDetails = { ...newInvestigation };

    const updatedDetails = [...investigations, newDetails];
    console.log("Investigation Updated Details", updatedDetails);
    setInvestigations(updatedDetails);

    // Reset form states
    setNewInvestigation({
      term: "",
      id: null,
      clinical_note: "",
    });
    setValidationErrors({});
    setInvestigationName("");
    setData(updatedDetails);
  };

  // Function to handle input changes
  const handleInputChange = (field, value) => {
    let newDetails;
    if (field == "term") {
      newDetails = {
        ...newInvestigation,
        [field]: value.term,
        id: value.id,
      };
    } else {
      newDetails = {
        ...newInvestigation,
        [field]: value,
      };
    }

    setNewInvestigation(newDetails);
  };

  // Function to handle row edit
  const handleEditRow = (index) => {
    setInvestigationName(investigations[index].term);
    setNewInvestigation({
      ...investigations[index],
      id: null,
      // clinical_note: "",
    });
    setEditingIndex(index);
    // handleDeleteRow(index); // Remove the row from the list temporarily
  };
  console.log("Editing Index", editingIndex);
  const handleUpdate = async () => {
    if (!validateFields()) return;

    let newDetails = { ...newInvestigation };

    newDetails = { ...newDetails, source: undefined };

    const updatedDetails = investigations.map((data, i) =>
      i === editingIndex ? newDetails : data
    );

    setInvestigations(updatedDetails);
    setEditingIndex(null);
    setNewInvestigation({
      term: "",
      id: null,
      clinical_note: "",
    });

    // Reset state like handleAdd
    setValidationErrors({});
    setInvestigationName("");
    setData(updatedDetails);
  };

  const handleDeleteRow = (index) => {
    let updatedDetails = investigations.filter((_, i) => i !== index);
    setInvestigations(updatedDetails);
    setData(updatedDetails);
  };
  const memoizedHandleCrossButtonClick = useCallback(
    (sectionName, suggestionName, type) => {
      handleCrossButtonClick(sectionName, suggestionName, type);
    },
    [handleCrossButtonClick]
  );
  const handleClearName = () => {
    setValidationErrors({});
    setInvestigationName("");
    setNewInvestigation({
      ...newInvestigation,
      id: null,
      term: "", // Use computed property name to set the field dynamically
    });
  };
  const handleConditionTyped = (value) => {
    setInvestigationName(value);
    handleInputChange("term", { term: value, id: null });
  };

  const handleSuggestionClick = (value) => {
    setInvestigationName(value);
    handleInputChange("term", { term: value, id: null });
  };

  console.log("Tests and Investigations data", investigations);
  return (
    <ThemeProvider theme={theme}>
      {activeSection && (
        <Grid item xs={12}>
          <Suggestions
            sectionName={sectionName}
            suggestions={suggestions}
            activeSection={activeSection}
            aiSuggestionToggle={aiSuggestionToggle}
            ruleSuggestionToggle={ruleSuggestionToggle}
            handleCrossButtonClick={memoizedHandleCrossButtonClick}
            handleSuggestionClick={handleSuggestionClick}
          />
        </Grid>
      )}
      {activeSection && (
        <Card
          sx={{
            borderRadius: "10px",
            boxShadow: "0 4px 4px 0 #C7C7CC inset",
            backgroundColor: "#FFF",
          }}
        >
          <Grid item xs={12} sm={12} md={12}>
            <Grid
              container
              spacing={2}
              sx={{
                marginTop: "5px",
                padding: "10px",
              }}
            >
              <Grid item xs={12} sm={8} md={6}>
                <StyledTextField
                  value={investigationName}
                  onChange={(e) => {
                    handleConditionTyped(e.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <div style={{ marginRight: "5px" }}>
                          <Tooltip title="Clear">
                            <OutlinedIconFab
                              size="small"
                              variant="contained"
                              onClick={handleClearName}
                            >
                              <Icon name="clearTextField" size={32} />
                            </OutlinedIconFab>
                          </Tooltip>
                        </div>

                        {/* <>
                          {isAiEnabled &&
                            (listeningOn === false ? (
                              <Tooltip title="Start Listening">
                                <OutlinedIconFab
                                  // onClick={startListening}
                                  onClick={() => {
                                    startRecording();
                                    setListeningOn(true);
                                  }}
                                  variant="contained"
                                  color="defaultColor"
                                  size="small"
                                >
                                  <Icon name="micNotInUse" size={32} />
                                </OutlinedIconFab>
                              </Tooltip>
                            ) : (
                              <Tooltip title="Stop Listening">
                                <OutlinedIconFab
                                  onClick={() => {
                                    // SpeechRecognition.stopListening();
                                    stopRecording("Tests/Investigations");
                                    setListeningOn(false);
                                  }}
                                  variant="outlined"
                                  color="defaultColor"
                                  size="small"
                                >
                                  <Icon name="micInUse" size={32} />
                                </OutlinedIconFab>
                              </Tooltip>
                            ))}
                        </> */}
                      </div>
                    ),
                  }}
                  label="Test/Investigation Name"
                  fullWidth
                  error={!!validationErrors.term} // Highlight field in red if there's an error
                  helperText={validationErrors.term} // Show error message
                />
              </Grid>

              <Grid item xs={12} sm={8} md={6}>
                <StyledMultilineTextField
                  value={newInvestigation.clinical_note}
                  onChange={(e) =>
                    handleInputChange("clinical_note", e.target.value)
                  }
                  placeholder="Clinical Notes"
                  fullWidth
                />
              </Grid>

              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <StyledButton
                  bgColor="#0E3F66"
                  onClick={editingIndex != null ? handleUpdate : handleAdd}
                  variant="contained"
                  sx={{
                    fontSize: { xs: "0.8rem", sm: "1rem" },
                    width: "100%",
                  }}
                >
                  {editingIndex != null ? "Update" : "Add"}
                </StyledButton>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      )}
      {investigations && (
        <InvestigationsSimplifiedTable
          data={investigations}
          activeSection={activeSection}
          handleEditRow={handleEditRow}
          handleDeleteRow={handleDeleteRow}
        />
      )}
    </ThemeProvider>
  );
};

export default InvestigationsSimplified;
